(function(){
  // Timing configuration
  const LOCK_DEFAULT_MS = 800;
  const LOCK_FAST_MS = 120;
  const PALETTE_VERIFY_FAST_MS = 40;
  const POLL_INTERVAL_MS = 100;
  const POLL_MAX_ATTEMPTS = 25;

  (function(){
    try {
      // Only enable on PDP where product-info exists
      if (!document.querySelector('product-info[data-section]')) return;
      const wrap = (proto) => {
        if (!proto.__customifySelectorWrapped) {
          const origQS = proto.querySelector;
          const origQSA = proto.querySelectorAll;
          const emptyNodeList = () => document.createDocumentFragment().querySelectorAll('*');
          const isBad = (selector) => {
            return (typeof selector === 'string'
              && selector.includes('input[type="radio"][name="')
              && /[\r\n]/.test(selector));
          };
          proto.querySelector = function(selector){
            try {
              return origQS.call(this, selector);
            } catch (e) {
              if (isBad(selector)) return null;
              throw e;
            }
          };
          proto.querySelectorAll = function(selector){
            try {
              return origQSA.call(this, selector);
            } catch (e) {
              if (isBad(selector)) return emptyNodeList();
              throw e;
            }
          };
          Object.defineProperty(proto, '__customifySelectorWrapped', { value: true, enumerable: false });
        }
      };
      wrap(Document.prototype);
      wrap(Element.prototype);
    } catch(_) { /* ignore if environment forbids wrapping */ }
  })();

  // Extract the foil/color value from the currently selected variant in the DOM
  function getVariantColorFromDOM(productRoot){
    try {
      const variantSelects = productRoot.querySelector('variant-selects');
      if (!variantSelects) return '';
      const selectedNode = variantSelects.querySelector('[data-selected-variant]');
      if (!selectedNode) return '';
      const data = JSON.parse(selectedNode.innerHTML);
      if (!data) return '';
      // Find index of the foil/color option among fieldsets
      const fieldsets = Array.from(variantSelects.querySelectorAll('fieldset'));
      const legends = fieldsets.map(fs => (fs.querySelector('legend')?.textContent || '').trim());
      const detected = detectFoilColorOption(variantSelects);
      const optName = detected.optionName;
      const idx = legends.findIndex(l => {
        let t = l.includes(':') ? l.split(':')[0].trim() : l;
        return norm(t) === norm(optName);
      });
      if (idx < 0) return '';
      // Pull value from variant options by index or fallback to optionN
      const byArray = Array.isArray(data.options) ? data.options[idx] : undefined;
      const byKey = data[`option${idx+1}`];
      const picked = (byArray || byKey || '').toString().trim();
      return picked;
    } catch(_){
      return '';
    }
  }

  function observeVariantSelectsReadiness(productRoot, onReady){
    const variantSelects = productRoot.querySelector('variant-selects');
    if (!variantSelects) return;
    const detected = detectFoilColorOption(variantSelects);
    const fs = detected.fieldset || variantSelects;
    const hasRadios = !!fs.querySelector('input[type="radio"]');
    if (hasRadios) { onReady(); return; }
    const obs = new MutationObserver(() => {
      if (fs.querySelector('input[type="radio"]').length !== undefined ? fs.querySelectorAll('input[type="radio"]').length > 0 : !!fs.querySelector('input[type="radio"]').length) {}
      if (fs.querySelector('input[type="radio"]')) {
        obs.disconnect();
        onReady();
      }
    });
    obs.observe(variantSelects, { childList: true, subtree: true });
  }

  function getAppCurrentColor(){
    const activeImg = document.querySelector('img.swapProduct.active[data-title]');
    const vt = activeImg?.getAttribute('data-title');
    let color = parseColorFromVariantTitle(vt);
    if (color) return color;

    const activeLi = document.querySelector('li.tooltip[data-title].active');
    const dt = activeLi?.getAttribute('data-title');
    if (dt) return dt.trim();

    const anyLi = document.querySelector('li.tooltip[data-title]');
    const dt2 = anyLi?.getAttribute('data-title');
    if (dt2) return dt2.trim();

    return '';
  }

  function ensureInitialSync(productRoot){
    const color = getAppCurrentColor();
    if (!color) return;
    D('Initial sync: selecting form swatch from app color:', color);
    selectFormSwatchByColor(productRoot, color);
  }

  function ensureFormHasSelection(productRoot){
    const variantSelects = productRoot.querySelector('variant-selects');
    if (!variantSelects) return;
    const detected = detectFoilColorOption(variantSelects);
    const fs = detected.fieldset;
    if (!fs) return;
    const checked = fs.querySelector('input[type="radio"]:checked');
    if (checked) return;

    const appColor = getAppCurrentColor();
    let target = null;
    if (appColor) {
      target = Array.from(fs.querySelectorAll('input[type="radio"]')).find(r => norm(r.value) === norm(appColor)) || null;
    }

    if (!target) {
      const legendSel = fs.querySelector('legend [data-selected-value]')?.textContent?.trim();
      if (legendSel) {
        target = Array.from(fs.querySelectorAll('input[type="radio"]')).find(r => norm(r.value) === norm(legendSel)) || null;
      }
    }

    if (!target) {
      target = Array.from(fs.querySelectorAll('input[type="radio"]:not(.disabled):not([disabled])'))[0] || null;
    }

    if (target) {
      D('Ensuring initial form selection with value:', target.value);
      const prev = window.__customifySyncLock;
      window.__customifySyncLock = true;
      try {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
        target.dispatchEvent(new Event('input', { bubbles: true }));
      } finally {
        setTimeout(() => { window.__customifySyncLock = prev; }, 300);
      }
    }
  }

  const D = () => {};
  const W = () => {};

  function norm(str){
    return String(str || '')
      .toLowerCase()
      .normalize('NFKD')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function mapColorForForm(appColor){
    return norm(appColor);
  }

  function parseColorFromVariantTitle(variantTitle){
    if(!variantTitle) return '';
    return String(variantTitle).split('/')[0].trim();
  }

  function detectFoilColorOption(variantSelects){
    const fieldsets = Array.from(variantSelects.querySelectorAll('fieldset'));
    const legends = fieldsets.map(fs => fs.querySelector('legend')?.textContent?.trim() || '');
    const candidates = [
      'Select Your Condom Foil Color',
      'Condom Foil Color',
      'Foil Color',
      'Foil colour',
      'Color',
      'Colour'
    ].map(norm);

    let picked = fieldsets.find(fs => {
      const l = norm(fs.querySelector('legend')?.textContent || '');
      return l.includes('foil') && (l.includes('color') || l.includes('colour'));
    });

    if (!picked) {
      picked = fieldsets.find(fs => candidates.includes(norm(fs.querySelector('legend')?.textContent || '')));
    }

    if (picked) {
      let legendTxt = (picked.querySelector('legend')?.textContent || '').trim();
      if (legendTxt.includes(':')) legendTxt = legendTxt.split(':')[0].trim();

      const nameAttr = picked.querySelector('input[type="radio"]')?.getAttribute('name');
      const m = nameAttr && nameAttr.match(/options\[(.+?)\]/);
      const optionName = m ? m[1] : legendTxt || 'Color';
      return { optionName, fieldset: picked };
    }

    const radios = Array.from(variantSelects.querySelectorAll('input[type="radio"]'));
    const groupNames = [...new Set(radios.map(r => r.getAttribute('name') || ''))];
    for (const name of groupNames) {
      const fs = variantSelects.querySelector(`input[name="${name}"]`)?.closest('fieldset');
      const legend = norm(fs?.querySelector('legend')?.textContent || '');
      if (legend && (legend.includes('foil') || legend.includes('color') || legend.includes('colour'))) {
        const m = name.match(/options\[(.+?)\]/);
        if (m) {
          return { optionName: m[1], fieldset: fs };
        }
      }
    }

    return { optionName: 'Color', fieldset: null };
  }

  function selectFormSwatchByColor(root, colorValue){
    if(!root || !colorValue) return false;
    const desired = mapColorForForm(colorValue);

    const variantSelects = root.querySelector('variant-selects');
    if(!variantSelects) return false;

    const detected = detectFoilColorOption(variantSelects);
    const OPTION_NAME = detected.optionName;
    const OPTION_FIELDSET = detected.fieldset;

    let radios = [];
    if (OPTION_FIELDSET) {
      radios = Array.from(OPTION_FIELDSET.querySelectorAll('input[type="radio"]'));
    } else {
      radios = Array.from(variantSelects.querySelectorAll('input[type="radio"]')).filter(r => r.getAttribute('name') === `options[${OPTION_NAME}]`);
    }

    let target = null;
    for(const r of radios){
      const val = norm(r.value);
      if(val === desired){
        target = r;
        break;
      }
    }

    let usingSelect = false;
    if(!target){
      const selectEl = Array.from(variantSelects.querySelectorAll('select')).find(s => s.getAttribute('name') === `options[${OPTION_NAME}]`);
      if (selectEl) {
        usingSelect = true;
        const opts = Array.from(selectEl.options).map(o => ({ value: o.value, text: o.textContent.trim() }));
        let match = Array.from(selectEl.options).find(o => norm(o.value) === desired) || Array.from(selectEl.options).find(o => norm(o.textContent) === desired);
        if (match) {
          target = selectEl;
          target.value = match.value;
        }
      }
    }

    if(!target){
      const fieldset = OPTION_FIELDSET || Array.from(variantSelects.querySelectorAll('fieldset')).find(fs => {
        const legend = norm(fs.querySelector('legend')?.textContent || '');
        return legend === norm(OPTION_NAME);
      });
      if(fieldset){
        const fsRadios = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
        target = fsRadios.find(r => norm(r.value) === desired) || null;
        if (!target) {
          const labels = fieldset.querySelectorAll('label');
          for(const label of labels){
            const labelVal = norm(label.getAttribute('data-value') || label.textContent || '');
            if(labelVal === desired){
              const forId = label.getAttribute('for');
              if(forId){
                target = document.getElementById(forId);
                break;
              }
            }
          }
        }
      }
    }

    if(!target){
      return false;
    }

    window.__customifySyncLock = true;

    if(usingSelect){
      try {
        target.dispatchEvent(new Event('change', { bubbles: true }));
        target.dispatchEvent(new Event('input', { bubbles: true }));
      } catch (e) { /* swallow vendor selector errors */ }
    } else if(!target.checked){
      target.checked = true;
      try {
        target.dispatchEvent(new Event('change', { bubbles: true }));
        target.dispatchEvent(new Event('input', { bubbles: true }));
      } catch (e) { /* swallow vendor selector errors */ }
    }

    setTimeout(() => { window.__customifySyncLock = false; }, LOCK_DEFAULT_MS);
    return true;
  }

  function wireFromCustomifyPalette(productRoot){
    document.addEventListener('click', function(e){
      if (window.__customifySyncInternalClick) {
        return;
      }
      const zone = e.target.closest('.cst-color-buttons') || e.target.closest('#cst-color-switcher') || e.target.closest('ul,ol');
      if(!zone) return;

      let el = e.target.closest('li.tooltip[data-title], [data-title],[data-color]');
      if(!el || !zone.contains(el)) {
        el = zone.querySelector('li.tooltip[data-title].active') || zone.querySelector('[data-title].active') || zone.querySelector('[data-title]') || zone.querySelector('[data-color]');
      }

      if(!el){
        return;
      }

      const appColor = el.getAttribute('data-title') || el.getAttribute('data-color') || el.textContent || '';
      if(!appColor) return;
      selectFormSwatchByColor(productRoot, appColor);
    }, true);
  }

  function appIsShowingColor(appColor){
    const desired = norm(appColor);
    const active = document.querySelector('img.swapProduct.active[data-title]') || document.querySelector('img.swapProduct[data-title].selected');
    const title = active?.getAttribute('data-title') || '';
    const prefix = norm(title).split(' / ')[0];
    return prefix === desired;
  }

  function chooseAppColor(appColor){
    const desired = norm(appColor);
    window.__customifySyncLock = true;

    if (clickAppThumbnail(appColor)) {
      setTimeout(() => { if (window.__customifySyncLock) { window.__customifySyncLock = false; } }, LOCK_DEFAULT_MS);
      return true;
    }

    const paletteZones = [
      document.querySelector('#cst-color-switcher .for-image'),
      document.querySelector('.cst-color-buttons.for-image'),
      document.querySelector('#cst-color-switcher'),
      document.querySelector('.cst-color-buttons')
    ].filter(Boolean);

    for (const zone of paletteZones){
      const candidates = Array.from(zone.querySelectorAll('[data-title],[data-color]'));
      const byTitle = candidates.find(el => norm(el.getAttribute('data-title') || el.textContent || '') === desired);
      if (byTitle){
        window.__customifySyncInternalClick = true;
        try {
          byTitle.dispatchEvent(new MouseEvent('pointerdown', {bubbles:true}));
          byTitle.dispatchEvent(new MouseEvent('mousedown', {bubbles:true}));
          byTitle.dispatchEvent(new MouseEvent('mouseup', {bubbles:true}));
          byTitle.dispatchEvent(new MouseEvent('click', {bubbles:true}));
        } catch(e) {
        } finally {
          setTimeout(()=>{ window.__customifySyncInternalClick = false; }, 0);
        }
        setTimeout(() => {
          if (!appIsShowingColor(appColor)) {
            clickAppThumbnail(appColor);
          }
        }, 150);
        setTimeout(() => { if (window.__customifySyncLock) { window.__customifySyncLock = false; } }, LOCK_DEFAULT_MS);
        return true;
      }
      const byTooltip = candidates.find(el => norm(el.getAttribute('title') || '') === desired);
      if (byTooltip){
        window.__customifySyncInternalClick = true;
        try {
          byTooltip.dispatchEvent(new MouseEvent('pointerdown', {bubbles:true}));
          byTooltip.dispatchEvent(new MouseEvent('mousedown', {bubbles:true}));
          byTooltip.dispatchEvent(new MouseEvent('mouseup', {bubbles:true}));
          byTooltip.dispatchEvent(new MouseEvent('click', {bubbles:true}));
        } catch(e) {
        } finally {
          setTimeout(()=>{ window.__customifySyncInternalClick = false; }, 0);
        }
        setTimeout(() => {
          if (!appIsShowingColor(appColor)) {
            clickAppThumbnail(appColor);
          }
        }, 150);
        setTimeout(() => { if (window.__customifySyncLock) { window.__customifySyncLock = false; } }, LOCK_DEFAULT_MS);
        return true;
      }
    }
    if (clickAppThumbnail(appColor)) {
      setTimeout(() => { if (window.__customifySyncLock) { window.__customifySyncLock = false; } }, LOCK_DEFAULT_MS);
      return true;
    }
    setTimeout(() => { if (window.__customifySyncLock) { window.__customifySyncLock = false; } }, LOCK_DEFAULT_MS);
    return false;
  }

  function chooseAppColorFast(appColor){
    const desired = norm(appColor);
    window.__customifySyncLock = true;
    if (clickAppThumbnail(appColor)) {
      setTimeout(() => { if (window.__customifySyncLock) { window.__customifySyncLock = false; } }, LOCK_FAST_MS);
      return true;
    }
    const paletteZones = [
      document.querySelector('#cst-color-switcher .for-image'),
      document.querySelector('.cst-color-buttons.for-image'),
      document.querySelector('#cst-color-switcher'),
      document.querySelector('.cst-color-buttons')
    ].filter(Boolean);
    for (const zone of paletteZones){
      const candidates = Array.from(zone.querySelectorAll('[data-title],[data-color]'));
      const byTitle = candidates.find(el => norm(el.getAttribute('data-title') || el.textContent || '') === desired);
      if (byTitle){
        window.__customifySyncInternalClick = true;
        try {
          byTitle.dispatchEvent(new MouseEvent('pointerdown', {bubbles:true}));
          byTitle.dispatchEvent(new MouseEvent('mousedown', {bubbles:true}));
          byTitle.dispatchEvent(new MouseEvent('mouseup', {bubbles:true}));
          byTitle.dispatchEvent(new MouseEvent('click', {bubbles:true}));
        } catch(e) {
        } finally {
          setTimeout(()=>{ window.__customifySyncInternalClick = false; }, 0);
        }
        setTimeout(() => {
          if (!appIsShowingColor(appColor)) {
            clickAppThumbnail(appColor);
          }
        }, PALETTE_VERIFY_FAST_MS);
        setTimeout(() => { if (window.__customifySyncLock) { window.__customifySyncLock = false; } }, LOCK_FAST_MS);
        return true;
      }
    }
    setTimeout(() => { if (window.__customifySyncLock) { window.__customifySyncLock = false; } }, LOCK_FAST_MS);
    return false;
  }

  function clickAppThumbnail(appColor){
    const desired = norm(appColor);
    const thumbs = Array.from(document.querySelectorAll('img.swapProduct[data-title]'));
    const thumb = thumbs.find(img => norm(img.getAttribute('data-title') || '').startsWith(desired + ' '));
    if (thumb){
      window.__customifySyncInternalClick = true;
      try {
        thumb.dispatchEvent(new MouseEvent('pointerdown', {bubbles:true}));
        thumb.dispatchEvent(new MouseEvent('mousedown', {bubbles:true}));
        thumb.dispatchEvent(new MouseEvent('mouseup', {bubbles:true}));
        thumb.dispatchEvent(new MouseEvent('click', {bubbles:true}));
      } catch(e) {
      } finally {
        setTimeout(()=>{ window.__customifySyncInternalClick = false; }, 0);
      }
      return true;
    }
    return false;
  }

  function wireFromCustomifyObserver(productRoot){
    let layer = document.querySelector('#layer-canvas-0');
    if(!layer){
      layer = document.querySelector('#cst-product') || document.querySelector('#cst-container') || document.querySelector('.image-view-container');
    }
    if(!layer){
      const thumbObserver = new MutationObserver(() => {
        const active = document.querySelector('img.swapProduct.active[data-title]');
        const vt = active?.getAttribute('data-title');
        const color = parseColorFromVariantTitle(vt);
        if(color){
          selectFormSwatchByColor(productRoot, color);
        }
      });
      thumbObserver.observe(document.documentElement || document.body, { childList: true, attributes: true, subtree: true, attributeFilter: ['class'] });
      return;
    }

    const observer = new MutationObserver(() => {
      const active = document.querySelector('img.swapProduct.active[data-title]');
      const vt = active?.getAttribute('data-title');
      let color = parseColorFromVariantTitle(vt);
      if(!color){
        const imgs = layer.querySelectorAll('img.swapProduct[data-title]');
        const candidate = imgs[imgs.length - 1];
        const v2 = candidate?.getAttribute('data-title');
        color = parseColorFromVariantTitle(v2);
      }
      if(color){
        selectFormSwatchByColor(productRoot, color);
      }
    });

    observer.observe(layer, { childList: true, attributes: true, subtree: true, attributeFilter: ['data-title', 'src', 'class'] });

    const thumbObserver = new MutationObserver(() => {
      const active = document.querySelector('img.swapProduct.active[data-title]');
      const vt = active?.getAttribute('data-title');
      const color = parseColorFromVariantTitle(vt);
      if(color){
        selectFormSwatchByColor(productRoot, color);
      }
    });
    thumbObserver.observe(document.documentElement || document.body, { childList: true, attributes: true, subtree: true, attributeFilter: ['class'] });
  }

  function initCustomifySync(){
    const productRoot = document.querySelector('product-info[data-section]');
    if(!productRoot) return;
    if(productRoot.__customifySyncBound) return;
    productRoot.__customifySyncBound = true;

    if(typeof window.__customifySyncLock === 'undefined'){
      window.__customifySyncLock = true;
    }
    let initialSynced = false;

    const hasVariantInUrl = /[?&]variant=/.test(location.search);
    if (hasVariantInUrl) {
      const colorFromVariant = getVariantColorFromDOM(productRoot);
      if (colorFromVariant) {
        let tries = 0;
        const MAX_TRIES = 30;
        const tick = () => {
          const thumbsReady = document.querySelector('img.swapProduct[data-title]');
          const paletteReady = document.querySelector('#cst-color-switcher, .cst-color-buttons');
          if (appIsShowingColor(colorFromVariant)) {
            selectFormSwatchByColor(productRoot, colorFromVariant);
            initialSynced = true;
            setTimeout(() => { window.__customifySyncLock = false; }, LOCK_FAST_MS);
            return;
          }
          if (thumbsReady || paletteReady) {
            chooseAppColorFast(colorFromVariant);
            setTimeout(() => { selectFormSwatchByColor(productRoot, colorFromVariant); }, 0);
            setTimeout(() => {
              if (appIsShowingColor(colorFromVariant)) {
                initialSynced = true;
                setTimeout(() => { window.__customifySyncLock = false; }, LOCK_FAST_MS);
              } else if (tries++ < MAX_TRIES) {
                setTimeout(tick, POLL_INTERVAL_MS);
              } else {
                window.__customifySyncLock = false;
              }
            }, PALETTE_VERIFY_FAST_MS);
          } else if (tries++ < MAX_TRIES) {
            setTimeout(tick, POLL_INTERVAL_MS);
          } else {
            window.__customifySyncLock = false;
          }
        };
        setTimeout(tick, 0);
      }
    }

    wireFromCustomifyPalette(productRoot);
    wireFromCustomifyObserver(productRoot);
    observeVariantSelectsReadiness(productRoot, () => {
      ensureFormHasSelection(productRoot);
      ensureInitialSync(productRoot);
      if (getAppCurrentColor()) initialSynced = true;
    });

    let attempts = 0;
    const maxAttempts = POLL_MAX_ATTEMPTS;
    const poll = () => {
      if (initialSynced) return;
      const c = getAppCurrentColor();
      if (c) {
        initialSynced = true;
        selectFormSwatchByColor(productRoot, c);
        setTimeout(() => { window.__customifySyncLock = false; }, LOCK_DEFAULT_MS);
        return;
      }
      attempts++;
      if (attempts < maxAttempts) {
        setTimeout(poll, POLL_INTERVAL_MS);
      } else {
        window.__customifySyncLock = false;
      }
    };
    setTimeout(poll, 0);

    let formToAppDebounceId = null;
    let lastRequestedColor = null;
    const scheduleFormToApp = (val, userInitiated = false) => {
      if (!val) return;
      if (userInitiated) {
        clearTimeout(formToAppDebounceId);
        lastRequestedColor = val;
        requestAnimationFrame(() => {
          if (appIsShowingColor(val)) return;
          chooseAppColorFast(val);
        });
        return;
      }
      lastRequestedColor = val;
      const run = () => {
        if (window.__customifySyncLock) {
          formToAppDebounceId = setTimeout(run, 30);
          return;
        }
        const color = lastRequestedColor;
        lastRequestedColor = null;
        requestAnimationFrame(() => {
          if (!color) return;
          if (appIsShowingColor(color)) return;
          chooseAppColor(color);
        });
      };
      clearTimeout(formToAppDebounceId);
      formToAppDebounceId = setTimeout(run, 0);
    };

    productRoot.addEventListener('change', (e) => {
      if (!(e.target instanceof HTMLInputElement)) return;
      if (e.target.type !== 'radio') return;
      const name = e.target.name;
      D('Variant change detected from theme:', name, '=>', e.target.value, 'lock:', !!window.__customifySyncLock);
      scheduleFormToApp(e.target.value, e.isTrusted === true);
    }, true);

    productRoot.addEventListener('pointerdown', (e) => {
      if (e.isTrusted !== true) return;
      let input = e.target instanceof HTMLInputElement ? e.target : null;
      if (!input) {
        const label = e.target.closest && e.target.closest('label.swatch-input__label, label[for]');
        if (label) {
          const forId = label.getAttribute('for');
          if (forId) input = document.getElementById(forId);
          if (!input && label.previousElementSibling instanceof HTMLInputElement) input = label.previousElementSibling;
        }
      }
      if (!input || input.type !== 'radio') return;
      const val = input.value;
      if (!val) return;
      D('Pointerdown preempt: scheduling fast app change for', val);
      scheduleFormToApp(val, true);
    }, true);

    productRoot.addEventListener('click', (e) => {
      const label = e.target.closest('label.swatch-input__label, label[for]');
      if (!label) return;
      let input = null;
      const forId = label.getAttribute('for');
      if (forId) input = document.getElementById(forId);
      if (!input) input = label.previousElementSibling instanceof HTMLInputElement ? label.previousElementSibling : null;
      if (!input || input.type !== 'radio') return;
      const val = input.value;
      D('Swatch label click detected. For:', forId, 'value:', val, 'lock:', !!window.__customifySyncLock);
      scheduleFormToApp(val, true);
    }, false);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initCustomifySync);
  } else {
    initCustomifySync();
  }
})();